module.exports = __webpack_public_path__ + "img/address.0bce842b.png";